import app from 'apprun';
import { __ } from '../Txlat';
export default function ({ agent }) {

  if (!agent) { return; }
  return (
    (agent.description || agent.awards || agent.languages || agent.spokenLang) ? <div class="agent-bio-wrap">
      <h2><b>{__('About')} {agent.name}</b></h2>
      {agent.description ? <div><p class="p1"><span class="s1">{'_html:' + agent.description}</span></p><br></br></div> : ''}
      {/* {agent.awards.includes('National Top 10% Royal LePage Commercial') ? <div><p class="p1 mb-1"><b>{__('Awards')}</b></p><p class="p1"><img src={__('https://www-d.royallepage.ca/wp-content/2019/02/award_logo_comm-national10_eng.jpg')}></img></p><br></br></div> : ''} */}
      {/* {agent.languages ? <div><p><i class="houzez-icon icon-messages-bubble mr-1"></i><strong>{__('Languages')}: </strong>{agent.languages}</p></div> : ''} */}
      {agent.spokenLang ? <div><p><i class="houzez-icon icon-messages-bubble mr-1"></i><strong>{__('Spoken Languages')}: </strong>{agent.spokenLang}</p></div> : ''}
    </div> : ''
  );
}
